<template>
    <div>
        <el-dialog title="审核信息发布" :visible.sync="dialogVisible" width="1200px" @close="handleClose">
            <div class="header_title">基本信息</div>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="155px" class="shouliao_content">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="车型" prop="ORMTB493CA02">
                            <el-select v-model="form.ORMTB493CA02" placeholder="请选择车型">
                                <el-option v-for="(item, index) in vehicleModelList" :key="index" :label="item"
                                    :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="厂家" prop="ORMTB493CA03">
                            <el-select v-model="form.ORMTB493CA03" placeholder="请选择厂家" @change="getList" filterable
                                disabled>
                                <el-option v-for="(item, index) in manuFacturerList" :key="index"
                                    :label="item.SETTB99CA00" :value="item.SETTB99ID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="扣款账户" prop="ORMTBSL410ID">
                            <el-select v-model="form.ORMTBSL410ID" placeholder="请选择代发运单账户" filterable>
                                <el-option v-for="(item, index) in accountList" :key="index" :label="item.ZHNAME"
                                    :value="item.ZHID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="物料类型" prop="ORMTB493CA05">
                            <el-select v-model="form.ORMTB493CA05" placeholder="请选择物料类型" disabled>
                                <el-option v-for="item in materialList" :key="item.settb109ID"
                                    :label="item.settb109CA00" :value="item.settb109ID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="卸货地" prop="ORMTB493CA20">
                            <el-input v-if="form.ORMTB493CA20" v-model="form.ORMTB493CA20" disabled></el-input>
                            <el-button type="primary" @click="handleLocation">地图定位</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" prop="ORMTB493CA21">
                            <el-input v-model="form.ORMTB493CA21" placeholder="请选择卸货地" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12" class="content_box">
                        <div class="content_box_item_1">
                            <el-form-item label="到货总价" prop="ORMTB493CA07" class="inclusiveType_box">
                                <el-input v-model="form.ORMTB493CA07" placeholder="请输入到货总价"
                                    @input="handleInput('ORMTB493CA07', $event)"></el-input>
                                <div class="inclusiveType_btn">
                                    <span :class="{ 'activeBlue': form.ORMTB493CA70 === item.value }"
                                        v-for="(item, index) in inclusiveType" :key="index"
                                        @click="handleInclusive(item.value)">{{ item.label }}</span>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="content_box_item_2">
                            <el-form-item v-if="form.ORMTB493CA70 == 0" label="发单运费价" prop="ORMTB493CA73"
                                class="inclusiveType_box content_box_item_label">
                                <el-input v-model="form.ORMTB493CA73" placeholder="请输入发单运费价"
                                    @input="handleInput('ORMTB493CA73', $event)"></el-input>
                                <div class="inclusiveType_btn unit_btn">元</div>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="运费价格" prop="ORMTB493CA09" class="inclusiveType_box">
                            <el-input v-model="form.ORMTB493CA09" placeholder="请输入运费价格"
                                @input="handleInput('ORMTB493CA09', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">元</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">

                    <!-- <el-col :span="12">
                        <el-form-item label="预估成本价格" prop="costPrice">
                            <el-input v-model.number="form.costPrice" placeholder="请输入预估成本价格"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="超时取消时间(小时)" prop="ORMTB493CA27">
                            <el-input v-model="form.ORMTB493CA27" placeholder="请输入超时取消时间(小时)"
                                @input="handleInput('ORMTB493CA27', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">小时</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="吨数" prop="ORMTB493CA08" class="incype_box">
                            <el-input v-model="form.ORMTB493CA08" placeholder="请输入吨数"
                                @input="handleInput('ORMTB493CA08', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">吨</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="结算运费甩零" prop="ORMTB493CA36">
                            <el-select v-model="form.ORMTB493CA36" placeholder="请选择">
                                <el-option v-for="(item, index) in shippingArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="亏吨范围(吨)" prop="ORMTB493CA25" class="inclusiveType_box">
                            <el-input v-model="form.ORMTB493CA25" placeholder="请输入亏吨范围(吨)"
                                @input="handleInput('ORMTB493CA25', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">吨</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="运费结算方式" prop="ORMTB493CA43">
                            <el-select v-model="form.ORMTB493CA43" placeholder="请选择运费结算方式" disabled>
                                <el-option v-for="(item, index) in feeArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="确认净重" prop="ORMTB493CA35">
                            <el-select v-model="form.ORMTB493CA35" placeholder="请选择">
                                <el-option v-for="(item, index) in dunArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="配送费" prop="ORMTB493CA48" class="inclusiveType_box">
                            <el-input v-model="form.ORMTB493CA48" placeholder="请输入配送费"
                                @input="handleInput('ORMTB493CA48', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">元</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="卸货时间" prop="ORMTB493CA37">
                            <el-date-picker v-model="form.ORMTB493CA37" type="datetimerange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" align="right"
                                :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm" @change="handleDateChange">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="管理费" prop="ORMTB493CA34" class="inclusiveType_box">
                            <el-input v-model="form.ORMTB493CA34" placeholder="请输入管理费"
                                @input="handleInput('ORMTB493CA34', $event)"></el-input>
                            <div class="inclusiveType_btn unit_btn">%</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="接单是否审核" prop="ORMTB493CA44">
                            <el-select v-model="form.ORMTB493CA44" placeholder="请选择接单是否审核">
                                <el-option v-for="(item, index) in examineArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="公开运单" prop="ORMTB493CA31">
                            <el-radio-group v-model="form.ORMTB493CA31">
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="隐藏运费接单价" prop="ORMTB493CA38">
                            <el-radio-group v-model="form.ORMTB493CA38">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="指定车辆" prop="ORMTB493CA30">
                            <el-radio-group v-model="form.ORMTB493CA30">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="冻结接单人物料金额" prop="ORMTB493CA32">
                            <el-radio-group v-model="form.ORMTB493CA32">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <template v-if="form.ORMTB493CA30 == 1">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="add_btn el-form-item" @click="addVehicle">添加车辆</div>
                            <div class="carBox">
                                <el-input style="width: 200px;margin-right: 10px;" v-model="carCode"
                                    placeholder="请输入车牌号" :clearable="true"></el-input>
                                <el-button type="primary" @click="searchCar">搜索</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12" v-if="selectedList.length > 0">
                            <div class="el-form-item" style="font-weight: 700;font-size: 14px;">指定车辆</div>
                            <div class="car_list" style="max-height: 150px;overflow-y: auto;">
                                <el-tag class="car_list_item" v-for="item in selectedList" :key="item" closable
                                    type="info" @close="handleCarClose(item)">
                                    {{ item }}
                                </el-tag>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                @change="handleCheckAllChange">全选</el-checkbox>
                        </el-col>
                        <el-checkbox-group v-model="checkedCar" @change="handleCheckedCitiesChange">
                            <el-col :span="12" v-for="(item, index) in carList" :key="index">
                                <div class="checkbox_item">
                                    <el-checkbox :label="item.SETTB402CA00" :key="item.SETTB402CA00">{{
                                        item.SETTB402CA00 }}</el-checkbox>
                                </div>
                            </el-col>
                        </el-checkbox-group>
                    </el-row>
                </template>
                <el-row>
                    <el-col :span="24" style="text-align: right;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">发布</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
        <!-- 添加车辆弹窗 -->
        <div class="addCarDialog">
            <el-dialog title="添加车辆" :visible.sync="addShow" width="1000px" @close="" :closeOnClickModal='false'>
                <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="127px" class="demo-ruleForm">
                    <div class="header_title">车辆信息</div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="车牌号" prop="SETTB402CA00">
                                <el-input v-model="addForm.SETTB402CA00"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="车主姓名" prop="SETTB402CA01">
                                <el-input v-model="addForm.SETTB402CA01"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系方式" prop="phone">
                                <el-input v-model="phone"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="皮重(吨)" prop="SETTB402CA03">
                                <el-input v-model="addForm.SETTB402CA03"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" style="text-align: right;">
                            <el-button @click="addShow = false">取消</el-button>
                            <el-button type="primary" @click="handleAddSubmit">添加</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
        </div>
        <!-- 地图定位弹窗 -->
        <amap :visible.sync="mapShow" @confirm="handleLocationConfirm" />
    </div>
</template>

<script>
import Amap from './Amap.vue';
export default {
    name: "AuditInfoDialog",
    components: {
        Amap
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        ORMTB493CA03: {
            type: String,
            default: '',
        },
        ORMTB493CA05: {
            type: String,
            default: '',
        },
        ORMTBSL410ID: {
            type: String,
            default: '',
        },
        ORMTB493CA20: {
            type: String,
            default: '',
        },
        ORMTB493CA21: {
            type: String,
            default: '',
        },
        ORMTB493CA22: {
            type: String,
            default: '',
        },
        ORMTB493CA23: {
            type: String,
            default: '',
        },
        ORMTB493CA07: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            selectedList: [],
            carCode: '',
            dialogVisible: this.visible,
            checkAll: false,
            checkedCar: [],
            isIndeterminate: true,
            addShow: false,
            mapShow: false,
            vehicleModelList: ['13米', '7米6', '9.6米'],//车型列表
            manuFacturerList: [],//厂家列表
            materialList: [],//物料列表
            accountList: [],//账户列表
            carList: [],//车辆列表
            inclusiveType: [
                { label: '不含税', value: 0 },
                { label: '含税', value: 1 },
            ],
            form: {
                ORMTB493CA02: '13米',
                SETTB99CA00: '',
                ORMTB493CA70: 1,//是否含税,默认含税
                ORMTBSL410ID: '',
                ORMTB493CA20: '',
                ORMTB493CA21: '',
                ORMTB493CA05: '',
                // materialPrice: '',
                ORMTB493CA07: '',
                ORMTB493CA09: '',
                // costPrice: 10,
                ORMTB493CA27: 24,
                ORMTB493CA08: '',
                ORMTB493CA36: -1,
                ORMTB493CA25: '',
                ORMTB493CA43: 0,
                ORMTB493CA35: 1,
                ORMTB493CA37: '',
                ORMTB493CA48: '',
                ORMTB493CA34: 0,
                ORMTB493CA44: 0,
                ORMTB493CA38: 0,
                ORMTB493CA31: 2,
                ORMTB493CA30: 2,
                ORMTB493CA32: 0,
                ORMTB493CA22: '',//经度
                ORMTB493CA23: '',//维度
                ormtb461List: [],//选中车牌
                ORMTB493CA73: ''
            },
            rules: {
                ORMTB493CA02: [
                    { required: true, message: '请选择车型', trigger: 'change' }
                ],
                ORMTB493CA03: [
                    { required: true, message: '请选择厂家', trigger: 'change' }
                ],
                ORMTBSL410ID: [
                    { required: true, message: '请选择扣款账户', trigger: 'change' }
                ],
                ORMTB493CA20: [
                    { required: true, message: '请输入卸货地', trigger: 'blur' }
                ],
                ORMTB493CA21: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                ORMTB493CA05: [
                    { required: true, message: '请选择物料类型', trigger: 'change' }
                ],
                ORMTB493CA07: [
                    { required: true, message: '请输入到货总价', trigger: 'blur' },
                ],
                ORMTB493CA09: [
                    { required: true, message: '请输入运费价格', trigger: 'blur' },
                ],
                ORMTB493CA27: [
                    { required: true, message: '请输入超时取消时间(小时)', trigger: 'blur' },
                ],
                ORMTB493CA08: [
                    { required: true, message: '请输入吨数', trigger: 'blur' },
                ],
                ORMTB493CA25: [
                    { required: true, message: '请输入亏吨范围(吨)', trigger: 'blur' },
                ]
            },
            addForm: {
                SETTB402CA00: '',
                SETTB402CA01: '',
                SETTB402CA03: '',
                SETTB402CA02: []
            },
            phone: '',//添加车辆电话
            addFormRules: {
                SETTB402CA00: [
                    { required: true, message: '请输入车牌号', trigger: 'change' }
                ],
            },
            dunArray: [
                {
                    type: 1,
                    title: '保留一位小数',
                },
                {
                    type: 2,
                    title: '保留两位小数',
                },
                {
                    type: 3,
                    title: '保留三位小数',
                },
            ],
            shippingArray: [
                {
                    type: -1,
                    title: '甩块',
                },
                {
                    type: 0,
                    title: '甩毛',
                },
                {
                    type: 1,
                    title: '甩分',
                },
                {
                    type: 2,
                    title: '不甩零',
                },
            ],
            feeArray: [
                {
                    type: 0,
                    title: '线上结算',
                },
                {
                    type: 1,
                    title: '线下结算',
                },
            ],
            examineArray: [
                {
                    type: 0,
                    title: '不审核',
                },
                {
                    type: 1,
                    title: '审核',
                },
            ],
            pickerOptions: {
                disabledDate(time) {
                    // 禁用今天之前的日期
                    return time.getTime() < Date.now() - 86400000;
                },
                onPick: ({ maxDate, minDate }) => {
                    // 当选择开始时间后，限制结束时间不能早于开始时间
                    if (minDate && !maxDate) {
                        this.pickerOptions.selectableRange = [
                            [minDate, new Date(2030, 12, 31, 23, 59)]
                        ];
                    }
                }
            }
        };
    },
    watch: {
        visible(newVal) {
            this.dialogVisible = newVal;
            this.carCode = '';
            if (newVal) {
                this.getManuFacturerList();
                this.getAccountList();
                this.getCarList();
            }
        },
        accountList: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    const hasMatch = this.accountList.some(user => user.ZHID === this.ORMTBSL410ID);
                    if (!hasMatch) {
                        this.form.ORMTBSL410ID = '';
                    }
                }
            },
            deep: true
        }
    },
    created() {
        this.getManuFacturerList();
        this.getAccountList();
        this.getCarList();
        this.form.ORMTB493CA03 = this.ORMTB493CA03;
        this.form.ORMTB493CA05 = this.ORMTB493CA05;
        this.form.ORMTBSL410ID = this.ORMTBSL410ID;
        this.form.ORMTB493CA20 = this.ORMTB493CA20;
        this.form.ORMTB493CA21 = this.ORMTB493CA21;
        this.form.ORMTB493CA22 = this.ORMTB493CA22;
        this.form.ORMTB493CA23 = this.ORMTB493CA23;
        this.form.ORMTB493CA07 = this.ORMTB493CA07;
    },
    methods: {
        handleCarClose(item) {
            // 从已选中车辆列表中移除
            this.selectedList = this.selectedList.filter(car => car !== item);

            // 如果该车辆在当前显示的列表中，更新复选框状态
            if (this.carList.some(car => car.SETTB402CA00 === item)) {
                this.checkedCar = this.checkedCar.filter(car => car !== item);
            }

            this.updateCheckAllState();
        },
        searchCar() {
            this.carList = [];
            this.checkAll = false;
            this.checkedCar = [];
            this.isIndeterminate = true;
            this.getCarList();
        },
        handleInput(field, value) {
            // 过滤非数字和小数点
            let filtered = value.replace(/[^\d.]/g, '');

            // 处理多个小数点的情况，只保留第一个
            const dotIndex = filtered.indexOf('.');
            if (dotIndex > -1) {
                filtered = filtered.substr(0, dotIndex + 1) +
                    filtered.substr(dotIndex + 1).replace(/\./g, '');
            }
            if (filtered.includes('.')) {
                const parts = filtered.split('.');
                if (parts[1].length > 2) {
                    filtered = parts[0] + '.' + parts[1].substr(0, 2);
                }
            }
            // 更新对应字段的值
            this.form[field] = filtered;
        },
        handleDateChange(val) {
            if (val && val.length === 2) {
                // 确保开始时间不早于当前时间
                const now = this.truncateToMinute(new Date());
                const start = this.truncateToMinute(new Date(val[0]));
                const end = this.truncateToMinute(new Date(val[1]));
                if (start < now) {
                    this.$message.warning('开始时间不能早于当前时间');
                    // 重置为当前时间
                    const formattedNow = this.formatDate(now);
                    this.form.ORMTB493CA37 = [];
                }
                if (end < now) {
                    this.$message.warning('结束时间不能早于当前时间');
                    const formattedNow = this.formatDate(now);
                    this.form.ORMTB493CA37 = [];
                }
            }
        },
        truncateToMinute(date) {
            const truncated = new Date(date);
            truncated.setSeconds(0);
            truncated.setMilliseconds(0);
            return truncated;
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        // 获取格式化后的时间字符串
        getFormattedTimeRange() {
            if (this.form.ORMTB493CA37 && this.form.ORMTB493CA37.length === 2) {
                return `${this.form.ORMTB493CA37[0]}~${this.form.ORMTB493CA37[1]}`;
            }
            return '';
        },
        //车辆列表
        getCarList() {
            this.axios.post('/set/settb402/selectSettb402BySign', { SETTB402CA00: this.carCode }).then(res => {
                if (res.data.code == 200) {
                    this.carList = res.data.data;
                    this.checkedCar = this.carList
                        .filter(item => this.selectedList.includes(item.SETTB402CA00))
                        .map(item => item.SETTB402CA00);

                    this.updateCheckAllState();
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        //获取扣款账户
        getAccountList() {
            this.axios.post('/set/settb402/selectYfAccount', {}).then(res => {
                if (res.data.code == 200) {
                    this.accountList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        handleInclusive(value) {//含税操作
            this.form.ORMTB493CA70 = value;
        },
        //获取厂家列表
        getManuFacturerList() {
            this.axios.post('/set/settb402/settb99SelectPageList', {}).then(res => {
                if (res.data.code == 200) {
                    this.manuFacturerList = res.data.data;
                    this.getMaterialList(this.ORMTB493CA03);
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        //获取物料类型
        getMaterialList(value) {
            this.axios.post('/set/settb402/ormtb440SelectAllSettb109', { SETTB99ID: value }).then(res => {
                if (res.data.code == 200) {
                    this.materialList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        getList(value) {
            this.getMaterialList(value);
        },
        handleLocationConfirm(res) {
            const [lng, lat] = res.lnglat;
            this.getAddress(lng, lat);
            // console.log(res, 'oopp')
            this.form.ORMTB493CA20 = res.address;
            this.form.ORMTB493CA22 = lng;
            this.form.ORMTB493CA23 = lat;
        },
        getAddress(lng, lat) {
            AMap.plugin('AMap.Geocoder', () => {
                const geocoder = new AMap.Geocoder();
                geocoder.getAddress([lng, lat], (status, result) => {
                    if (status === 'complete' && result.info === 'OK') {
                        this.form.ORMTB493CA21 = result.regeocode.formattedAddress;
                        console.log(result.regeocode.formattedAddress, '详细地址', result);
                    }
                });
            });
        },
        addVehicle() {
            this.addShow = true;
        },
        handleAddSubmit() {
            this.$refs.addForm.validate((valid) => {
                this.addForm.SETTB402CA02[0].phone = this.phone;
                if (valid) {
                    this.axios.post('/set/settb402/insertApp', this.addForm).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success',
                            })
                            this.addShow = false;
                            this.getCarList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                        }
                    })

                }
            });
        },
        handleCheckAllChange(val) {
            const currentCarPlates = this.carList.map(item => item.SETTB402CA00);

            if (val) {
                // 全选：添加当前列表中的所有车辆到已选中列表
                this.selectedList = [...new Set([...this.selectedList, ...currentCarPlates])];
                this.checkedCar = [...currentCarPlates];
            } else {
                // 取消全选：只移除当前列表中的车辆，保留其他已选车辆
                this.selectedList = this.selectedList.filter(plate => !currentCarPlates.includes(plate));
                this.checkedCar = [];
            }

            this.isIndeterminate = false;
            this.updateCheckAllState();
        },
        updateCheckAllState() {
            const currentCarPlates = this.carList.map(item => item.SETTB402CA00);
            const checkedInCurrent = this.selectedList.filter(plate =>
                currentCarPlates.includes(plate)
            );

            this.checkAll = checkedInCurrent.length > 0 &&
                checkedInCurrent.length === currentCarPlates.length;
            this.isIndeterminate = checkedInCurrent.length > 0 &&
                checkedInCurrent.length < currentCarPlates.length;
        },
        handleCheckedCitiesChange(checkedValues) {
            // 获取当前列表中所有车辆车牌号
            const currentCarPlates = this.carList.map(item => item.SETTB402CA00);

            // 更新选中列表：移除当前列表中不再选中的，添加新选中的
            const newSelectedList = [
                ...this.selectedList.filter(plate => !currentCarPlates.includes(plate)), // 保留不在当前列表中的已选车辆
                ...checkedValues // 添加当前列表中新选中的车辆
            ];

            this.selectedList = [...new Set(newSelectedList)]; // 去重
            this.updateCheckAllState();
        },
        handleClose() {
            this.dialogVisible = false;
            this.$emit('update:visible', false);
        },
        handleLocation() {
            this.mapShow = true;
        },
        handlePosition() {
            // 定位逻辑，可根据实际需求实现
            console.log('执行定位操作');
        },
        handleSubmit() {
            if (!this.form.ORMTBSL410ID) {
                return this.$message({
                    message: '账户未开启代下单授权请重新操作',
                    type: 'warning'
                })
            }
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.form.ORMTB493CA30 == 1) {
                        if (this.selectedList.length == 0) {
                            return this.$message({
                                message: '请选择车辆',
                                type: 'warning'
                            })
                        } else {
                            let arrCar = [];
                            this.selectedList.forEach(item => {
                                let obj = {
                                    carPlate: item,
                                }
                                arrCar.push(obj)
                            })
                            this.form.ormtb461List = arrCar;
                        }
                    }
                    this.form.ORMTB493CA34 = this.form.ORMTB493CA34 ? ((this.form.ORMTB493CA34) / 100) : 0;
                    this.form.ORMTB493CA37 = this.getFormattedTimeRange();
                    this.$emit('submit', this.form);
                }
            });
        }
    }
};
</script>
<style scoped>
.header_title {
    font-size: 18px;
    color: #333;
    border-top: 1px solid #D9D9D9;
    padding: 20px 0 20px;
    box-sizing: border-box;
}

/deep/.el-dialog {
    margin-top: 7vh !important;
}

/deep/.el-dialog__body {
    padding-top: 0;
}

/deep/.el-form-item__label {
    width: 155px !important;
    padding: 0 !important;
    text-align: left !important;
    font-size: 16px !important;
}

.addCarDialog /deep/.el-form-item__label {
    width: 127px !important;
}
/deep/.el-select {
    width: 100% !important;
}

.shouliao_content {
    height: 70vh;
    overflow-y: auto;
    overflow: -moz-scrollbars-none;
    /* 旧版 Firefox */
    scrollbar-width: none;
    /* 新版 Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.add_btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 12px;
    background: #199FFF;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
}

/deep/.el-checkbox__inner {
    width: 24px;
    height: 24px;
    border-radius: 4px;
}

/deep/.el-checkbox__inner::after {
    height: 12px;
    left: 9px;
    top: 3px;
    width: 4px;
}

/deep/.el-checkbox__inner::before {
    top: 10px !important;
}

/deep/.el-checkbox__label {
    font-size: 19px;
    vertical-align: middle;
}

.checkbox_item {
    width: 445px;
    height: 58px;
    line-height: 58px;
    background: #F5F7FA;
    border-radius: 6px;
    margin: 12px 0;
    padding-left: 20px;
    box-sizing: border-box;
}

.inclusiveType_box {
    position: relative;
}

.inclusiveType_btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #9E9E9E;
    cursor: pointer;
}

.inclusiveType_btn>span {
    margin-right: 14px;
}

.activeBlue {
    color: #199FFF;
}

.unit_btn {
    margin-right: 12px;
}

.carBox {
    display: flex;
    margin-bottom: 20px;
}

.car_list::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.car_list_item {
    margin-bottom: 10px;
    margin-left: 0 !important;
    margin-right: 10px;
}

.content_box {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* 可选，设置元素间距 */
}

.content_box_item_1 {
    width: 312px;
}
.content_box_item_2 {
    flex:1;
}
/deep/.content_box_item_label .el-form-item__label {
    width: 90px !important;
}
/deep/.content_box_item_label .el-form-item__content{
    margin-left: 90px!important;
}
</style>